import { Howl } from 'howler';
    
// This file is generated. Do not touch.

export const Fizz = new Howl({
    src: [require("./sound/fizz.ogg"), require("./sound/fizz.mp3")]
});

export const Hallelujah = new Howl({
    src: [require("./sound/hallelujah.ogg"), require("./sound/hallelujah.mp3")]
});

export const Music = new Howl({
    src: [require("./sound/music.ogg"), require("./sound/music.mp3")]
});

export const PlaceInEmptyTub = new Howl({
    src: [require("./sound/place in empty tub.ogg"), require("./sound/place in empty tub.mp3")]
});

export const TubDrain = new Howl({
    src: [require("./sound/tub drain.ogg"), require("./sound/tub drain.mp3")]
});

export const TubFill = new Howl({
    src: [require("./sound/tub fill.ogg"), require("./sound/tub fill.mp3")]
});

export const TubOverdrain = new Howl({
    src: [require("./sound/tub overdrain.ogg"), require("./sound/tub overdrain.mp3")]
});

export const TubOverfill = new Howl({
    src: [require("./sound/tub overfill.ogg"), require("./sound/tub overfill.mp3")]
});
